var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptypetcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 111,
    viewBox: "0 0 139 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 57.9314,
    r: 49,
    stroke: "#CCC3FE",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.1429 63.9671C87.0305 63.9671 87.75 63.2476 87.75 62.36V59.5029C87.75 58.6153 87.0305 57.8957 86.1429 57.8957H74.1429C74.0837 57.8957 74.0357 57.8477 74.0357 57.7886V45.7886C74.0357 44.901 73.3162 44.1814 72.4286 44.1814H69.5714C68.6838 44.1814 67.9643 44.901 67.9643 45.7886V57.7886C67.9643 57.8477 67.9163 57.8957 67.8571 57.8957H55.8571C54.9695 57.8957 54.25 58.6153 54.25 59.5029V62.36C54.25 63.2476 54.9695 63.9671 55.8571 63.9671H67.8571C67.9163 63.9671 67.9643 64.0151 67.9643 64.0743V76.0743C67.9643 76.9619 68.6838 77.6814 69.5714 77.6814H72.4286C73.3162 77.6814 74.0357 76.9619 74.0357 76.0743V64.0743C74.0357 64.0151 74.0837 63.9671 74.1429 63.9671H86.1429Z",
    fill: "#6B48FF",
    stroke: "#6B48FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.536 32.3099C112.536 32.3099 116.611 22.2383 119.949 18.1897C121.978 15.728 127.238 13.1336 131.05 11.4779C132.661 10.778 132.732 8.50692 131.075 7.92137C114.947 2.21971 96.4503 7.37819 93.9741 14.059",
    stroke: "#CCC3FE",
    strokeWidth: 9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3401 32.3102C26.3401 32.3102 22.2651 22.238 18.9273 18.1891C16.8978 15.7272 11.637 13.1325 7.82492 11.4768C6.21353 10.7769 6.14336 8.50578 7.79972 7.92022C23.9293 2.21802 42.4272 7.37687 44.9036 14.0581",
    stroke: "#CCC3FE",
    strokeWidth: 9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptypetcard);
export default __webpack_public_path__ + "static/media/emptypetcard.2dba954a.svg";
export { ForwardRef as ReactComponent };